import { SEARCH_ON_CHANGE, SEARCH_CHANGE_TYPE } from "./constants";

const initialState = {
  searchText: "",
  searchType: "directory", // message-user
};

const reducer = function searchReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_ON_CHANGE:
      return { ...state, searchText: action.payload };

    case SEARCH_CHANGE_TYPE:
      return { ...state, searchType: action.payload };
    default:
      return state;
  }
};

export default reducer;
